import { Button } from "@gigpro/ui/Button";
import { Lock } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import type { JobsTeaserCopy } from "domains/hire/jobsPlan";

type JobsTeaserCtaProps = {
  copy: JobsTeaserCopy;
  onAction: () => void;
  className?: string;
  /** A line under the body, e.g. telling Qwick staff why they can still post. */
  note?: string;
};

export const JobsTeaserCta = ({ copy, onAction, className, note }: JobsTeaserCtaProps) => (
  <section
    aria-label="Jobs plan"
    className={cn(
      "flex flex-col gap-3 rounded-sm border border-light-gray bg-white p-4 md:flex-row md:items-center",
      className,
    )}
  >
    <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-background">
      <Lock className="size-5 text-brand" />
    </div>
    <div className="flex-1 space-y-1">
      <h3 className="text-large font-semibold text-black">{copy.title}</h3>
      <p className="text-normal text-gray">{copy.body}</p>
      {note && <p className="text-small text-medium-gray">{note}</p>}
    </div>
    {copy.action && (
      <div className="flex flex-col items-stretch gap-1 md:items-end">
        <Button variant="contained" onClick={onAction}>
          {copy.actionLabel}
        </Button>
        {copy.footnote && <p className="text-small text-medium-gray">{copy.footnote}</p>}
      </div>
    )}
  </section>
);
